import { WSButton } from "@wingspanhq/fe-component-library";
import { useHistory } from "react-router-dom";
import { useModalFormW9Consent } from "../../ModalW9Consent/useModalFormW9Consent";
import { NotificationTemplate } from "../index";
import { selectorPayerNameFromContext } from "../../../selectors/selectorPayerNameFromContext";
import { selectorPayerIdFromContext } from "../../../selectors/selectorPayerIdFromContext";
import { PayerNotificationContext } from "../types";

export type W9ConsentContext = PayerNotificationContext;

export const W9Consent: NotificationTemplate<W9ConsentContext> = {
  renderTitle: props => "W-9 consent required",
  renderBody: props => {
    return (
      <>
        {props.group.length === 1 ? (
          <>
            <b>{selectorPayerNameFromContext(props.context)}</b> requires
          </>
        ) : props.group.length === 2 ? (
          <>
            <b>{selectorPayerNameFromContext(props.group[0].context)}</b> and{" "}
            <b>{selectorPayerNameFromContext(props.group[1].context)}</b>{" "}
            require
          </>
        ) : props.group.length === 3 ? (
          <>
            <b>{selectorPayerNameFromContext(props.group[0].context)}</b>,{" "}
            <b>{selectorPayerNameFromContext(props.group[1].context)}</b> and{" "}
            <b>{selectorPayerNameFromContext(props.group[2].context)}</b>{" "}
            require
          </>
        ) : (
          <>
            <b>{selectorPayerNameFromContext(props.group[0].context)}</b>,{" "}
            <b>{selectorPayerNameFromContext(props.group[1].context)}</b> and
            others require
          </>
        )}{" "}
        that you consent to share your W-9 information in order to get paid.
      </>
    );
  },
  Footer: props => {
    const history = useHistory();
    const consentModal = useModalFormW9Consent();

    return (
      <WSButton.Link
        size="S"
        rightIcon="chevron-right"
        onClick={() => {
          if (props.group.length === 1) {
            consentModal.open(
              {
                payers: [
                  {
                    payerId: selectorPayerIdFromContext(props.context)!,
                    name: selectorPayerNameFromContext(props.context)!
                  }
                ]
              },
              {
                title: `Share your W-9 information with ${selectorPayerNameFromContext(
                  props.context
                )}`
              }
            );
          } else {
            history.push("/member/dashboard/w9-consent");
          }
        }}
      >
        {props.group.length === 1
          ? `Consent to share W-9 information`
          : `Share W-9 information`}
      </WSButton.Link>
    );
  }
};
